import ajax from "@/lib/ajax";

// 查询新入院患者列表
export async function QueryPDMoveOutList(payload: any) {
    let res = await ajax.post(`/api/services/app/PDMoveOut/QueryPDMoveOutList`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdMoveOut/index.ts